import { ReactNode } from 'react'
import Header from './Header'
import Tabbar from './Tabbar'
import PageHeader from './PageHeader'
import { useAppStore } from '@/stores/app'

interface LayoutProps {
  children: ReactNode
  showTabbar?: boolean
  title?: string
}

export default function Layout({ children, showTabbar = false, title }: LayoutProps) {
  const unreadNotifications = useAppStore((s) => s.unreadNotifications)
  return (
    <div className="min-h-screen bg-bg flex flex-col mx-auto" style={{ maxWidth: 430 }}>
      {showTabbar && <Header notificationCount={unreadNotifications} />}
      {title && <PageHeader title={title} />}

      <main
        className={
          showTabbar
            ? 'flex-1 pt-14 pb-20'
            : title
              ? 'flex-1 pt-14'
              : 'flex-1'
        }
      >
        {children}
      </main>

      {showTabbar && <Tabbar />}
    </div>
  )
}
